module.exports = __webpack_public_path__ + "media/newstyle/images/agbook-logo-mobile-03fe2959c0552996c5d665b174a41942.png";